import React from 'react';
import {Background, SignInCardContainer} from './sign_in_page_styles';
import SignIn from "../../components/sign_in";
import {Routes} from "../../components/constants";
import SignUp from "../../components/sign_up";
import SignUpAccCreatedView from "../../components/sign_up/sign_up_acc_created_view";

function AccountCreated(props) {
    return <Background>
        <SignInCardContainer>
            <SignUpAccCreatedView {...props}/>
        </SignInCardContainer>
    </Background>;
}

export default AccountCreated;